import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class SocialNetworkList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };
    this.insertSocial = this.insertSocial.bind(this);
  }

  insertSocial() {
    this.props.history.push("/social/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}configuration/social/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.setState(
              () => ({
                list: null
              }),
              () => {
                if (resp.data.data.length === 0) {
                  this.setState(() => ({
                    list: [],
                    loading: false
                  }));
                } else {
                  this.setState(
                    () => ({
                      list: resp.data.data,
                      loading: false
                    }),
                    () => {
                      this.forceUpdate();
                    }
                  );
                }
              }
            );
          } else {
            this.props.logout(this.props.user.token);
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/social/edit/"
                  title="Redes Sociais"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "site", denomination: "Site" },
                    { name: "icon", denomination: "Ícone" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertSocial}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SocialNetworkList);
